module.exports = __webpack_public_path__ + "static/collectorcans-kait-red-artwork-44edf0fa92981c1c67a5557f9edb6e61.png";